/** Emitted after verify/reject (or bulk refresh) so the sidebar pending count can update. */
export const EDUCATION_QUALIFICATIONS_CHANGED_EVENT = 'education-qualifications-changed'
